/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPharmacy } from 'app/shared/model/pharmacy.model';

export interface IPharmacyDrugBrandNames {
  id?: string;
  brandName?: string | null;
  genericName?: string | null;
  drugType?: string | null;
  drugUnit?: string | null;
  unitPrice?: number | null;
  timestampentry?: number;
  microSec?: number;
  lastupdated?: number;
  active?: boolean;
  cursor?: number;
  pharmacy?: IPharmacy | null;
}

export const defaultValue: Readonly<IPharmacyDrugBrandNames> = {
  active: false,
};
